import createDataContext from './createDataContext';
import reducer, { ACTIONS } from './reducer';
import Service from '@/app/utils/service';
import {
    UnitOrgTreeItem,
} from '@/old/utils/helper';
import { OptionType } from '../types';

const ENDPOINTS = {
    unitOrgTree: () => '/org/tree/1/unit',
};

type WorklistOrganizationState = {
    orgTree: UnitOrgTreeItem[];
    allUnitOptions: OptionType[],
    loading: boolean;
    loadingId?: number;
    error: string;
};

export type WorklistContextState = {
    organization: WorklistOrganizationState;
};

const initialState: WorklistContextState = {
    organization: {
        orgTree: [],
        allUnitOptions: [],
        loading: false,
        error: undefined,
    },
};

const getUnitOrgTree = (dispatch: any) => {
    return async () => {
        dispatch({ type: ACTIONS.GET_UNIT_ORG_TREE });
        Service.get(
            `/d/json${ENDPOINTS.unitOrgTree()}`,
            (response: any) => {
                const orgTreeData = response.map((respItem: any) => ({
                    id: parseInt(respItem.fTreeId, 10),
                    parentId:
                        respItem.fTreeParentUnitId === '#'
                            ? '#'
                            : parseInt(respItem.fTreeParentUnitId, 10),
                    unitId: parseInt(respItem.fTreeUnitId, 10),
                    name: respItem.fTreeUnitName,
                    unitType: respItem.fTreeUnitType,
                }));
                dispatch({
                    type: ACTIONS.GET_UNIT_ORG_TREE_DONE,
                    payload: orgTreeData,
                });
            },
            (e: any) => {
                dispatch({ type: ACTIONS.GET_UNIT_ORG_TREE_ERROR, payload: e });
            },
        );
    };
};

export const { Context, Provider } = createDataContext(
    reducer,
    {
        getUnitOrgTree,
    },
    initialState,
);

export default Context;
